module.exports = __webpack_public_path__ + "img/gift.1e4ef896.png";